export default __webpack_public_path__ + "static/media/medical.b26beb7a.svg";